<template>
  <div class="flex">
    <div class="absolute top-0 left-0 w-full h-full search-full-container" :class="{'flex': showFullSearch}" v-show="showFullSearch">
      <vx-auto-suggest
        ref="VxAutoSuggest"
        :autoFocus="showFullSearch"
        :data="navbarSearchAndPinList"
        search_key="title"
        background-overlay
        class="w-full"
        inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus"
        icon="SearchIcon"
        placeholder="Explore System..."
        @input="hnd_search_query_update"
        @selected="selected"
        @closeSearchbar="showFullSearch = false">

        <template v-slot:group="{ group_name }">
          <p class="font-semibold text-primary">{{ group_name | title }}</p>
        </template>

        <!-- Pages Suggestion -->
        <template v-slot:pages="{ suggestion }">
          <div class="flex items-end py-1 leading-none">
            <feather-icon :icon="suggestion.icon" svgClasses="h-5 w-5" class="mr-4" />
            <span class="mt-1">{{ suggestion.title }}</span>
          </div>
        </template>

        <!-- No Items Slot -->
        <template v-slot:noResult="{ group_name }">
          <div class="flex items-center">
            <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" class="mr-4" />
            <span>No results found.</span>
          </div>
        </template>

      </vx-auto-suggest>

      <div class="absolute right-0 z-50 h-full">
        <feather-icon
          icon="XIcon"
          class="h-full px-4 cursor-pointer close-search-icon"
          @click="showFullSearch = false" />
      </div>
    </div>
    <feather-icon icon="SearchIcon" @click="showFullSearch = true" class="ml-4 cursor-pointer navbar-fuzzy-search" />
  </div>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  const GlobalRepository = RepositoryFactory.get('global')

export default {
  name: 'SearchNav',
  components: {
    VxAutoSuggest
  },
  data () {
    return {
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      showFullSearch: false
    }
  },
  methods: {
    selected (item) {
      // if (item.pages) this.$router.push(item.pages.url).catch(() => {})
      // this.showFullSearch = false
    },
    async hnd_search_query_update(query) {
      const {data} = (await GlobalRepository.getGlobalSearch(query)).data

      const search = data.map((x) => {
          return {
            type: x.type,
            url: x.url
          }
      })

      await this.$refs.VxAutoSuggest.loadSearch(search)

      this.$store.commit('TOGGLE_CONTENT_OVERLAY', !!query)
    },
  },
  async mounted () {

  },
  mixins: [SuccessMessage, ErrorMessages],
}

</script>
